import { call, put } from 'redux-saga/effects';
import { orderListRequestActions } from '../orders-lists';
import { locationsListRequestActions } from '../locations-lists';
import { specialtiesListRequestActions } from '../specialties-lists';
import { provincesListRequestActions } from '../provinces-lists';
import { locationsRequestActions } from '../locations';
import { practiceListRequestActions } from '../practice-lists';
import { providerRequestActions } from '../providers';
import { efectorlistRequestActions } from '../efector-lists';
import { efectoresImportLogRequestActions } from '../efectores-import-log';
import { efectorRequestActions } from '../efectores';
import { practiceEfectoresRequestActions, practiceEfectoresDeleteActions, practiceEfectoresUpdateActions } from '../practice-efectores';
import { practicePracticeEfectorVisitsRequestActions } from '../practice-efector-visits';
import { addressRequestActions } from '../address';
import { notificationListRequestActions } from '../notifications-lists';
import { notificationRequestActions } from '../notifications';
import { appActions } from '../app';

import { api } from './api-service';

function* fetchEntities(apiFunction, actions, id, param) {

  try {
    yield put(actions.pending(id));
    const response = yield call(apiFunction, param || id);
    if ( response.errors ){
      yield put(actions.failed(response.errors, id));
      if (response.errors == 401)
        yield put(appActions.navigateToPath("/401"))
    }
    else {
      if ( response.error && response.error.code !== 0 ) {
        yield put(actions.failed(response.error, id));
      }
      else
        yield put(actions.success(id, response));
    }
  }
  catch (error) {
    yield put(actions.failed(error, id));
    if ( error == 401 )
      yield put(appActions.navigateToPath("/401"))
  }
}

export const fetchOrders = fetchEntities.bind(null, api.fetchOrders, orderListRequestActions);
export const fetchLocations = fetchEntities.bind(null, api.fetchLocations, locationsListRequestActions);
export const fetchSpecialties = fetchEntities.bind(null, api.fetchSpecialties, specialtiesListRequestActions);
export const fetchPracticesByOrder = fetchEntities.bind(null, api.fetchPracticesByOrder, practiceListRequestActions);
export const fetchProvider = fetchEntities.bind(null, api.fetchProvider, providerRequestActions);
export const fetchEfectores = fetchEntities.bind(null, api.fetchEfectores, efectorlistRequestActions);
export const fetchEfector = fetchEntities.bind(null, api.fetchEfector, efectorRequestActions);
export const updateEfector = fetchEntities.bind(null, api.updateEfector, efectorRequestActions);
export const createEfector = fetchEntities.bind(null, api.createEfector, efectorRequestActions);
export const fetchEfectoresByPractice = fetchEntities.bind(null, api.fetchEfectoresByPractice, practiceEfectoresRequestActions);
export const fetchProvinces = fetchEntities.bind(null, api.fetchProvinces, provincesListRequestActions);
export const addPracticeEfector = fetchEntities.bind(null, api.addPracticeEfector, practiceEfectoresRequestActions);
export const deletePracticeEfector = fetchEntities.bind(null, api.deletePracticeEfector, practiceEfectoresDeleteActions);
export const fetchLocation = fetchEntities.bind(null, api.fetchLocation, locationsRequestActions);
export const fetchVisitsByPracticeEfector = fetchEntities.bind(null, api.fetchVisitsByPracticeEfector, practicePracticeEfectorVisitsRequestActions);
export const fetchAddres = fetchEntities.bind(null, api.fetchAddres, addressRequestActions);
export const updatePracticeEfector = fetchEntities.bind(null, api.updatePracticeEfector, practiceEfectoresUpdateActions);
export const fetchNotifications = fetchEntities.bind(null, api.fetchNotifications, notificationListRequestActions);
export const updateStatusNotification = fetchEntities.bind(null, api.updateStatusNotification, notificationRequestActions);
export const rejectPractice = fetchEntities.bind(null, api.rejectPractice, practiceListRequestActions);
export const importEfectores = fetchEntities.bind(null, api.importEfectores, efectoresImportLogRequestActions);
export const resendLoginMailEfector = fetchEntities.bind(null, api.resendLoginMailEfector, efectorRequestActions);


//
//
